module.exports = __webpack_public_path__ + "static/img/pro7.ecc56822.jpg";